"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuerySearchDeserializeFromApi = exports.getItemDeserializeFromApi = exports.getItemsDeserializeFromApi = exports.getItemsPayloadServer = void 0;
const tslib_1 = require("tslib");
const deserializer_1 = tslib_1.__importDefault(require("../utils/deserializer"));
function getItemsPayloadServer(responseRequestData) {
    try {
        let mappingData = [];
        if (!Array.isArray(responseRequestData)) {
            mappingData = responseRequestData === null || responseRequestData === void 0 ? void 0 : responseRequestData.data;
        }
        else {
            mappingData = responseRequestData;
        }
        const data = mappingData.map((item) => {
            var _a, _b, _c;
            return ({
                ...item,
                meta: {
                    ...item.meta,
                    category_id: Number(((_c = (_b = (_a = item.relationships) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id) || 0),
                    lowest_price_rule: getLowestPricingRule(item.attributes.pricing_rules),
                },
            });
        });
        responseRequestData.data = data;
        const payload = (0, deserializer_1.default)(responseRequestData);
        return payload;
    }
    catch {
        return {};
    }
}
exports.getItemsPayloadServer = getItemsPayloadServer;
function getLowestPricingRule(pricingRules) {
    let lowestRule = null;
    for (const rule of pricingRules) {
        if (!lowestRule || rule.minutes < lowestRule.minutes) {
            lowestRule = rule;
        }
    }
    return lowestRule;
}
function getItemsDeserializeFromApi(response) {
    try {
        const data = response.data.data.map((item) => {
            var _a, _b, _c;
            return ({
                ...item,
                meta: {
                    ...item.meta,
                    category_id: Number(((_c = (_b = (_a = item.relationships) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id) || 0),
                    lowest_price_rule: getLowestPricingRule(item.attributes.pricing_rules),
                },
            });
        });
        response.data.data = data;
        return (0, deserializer_1.default)(response.data);
    }
    catch {
        return {};
    }
}
exports.getItemsDeserializeFromApi = getItemsDeserializeFromApi;
function getItemDeserializeFromApi(response) {
    var _a, _b, _c;
    try {
        response.data.data.meta.category_id = Number(((_c = (_b = (_a = response.data.data.relationships) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.id) || 0);
        response.data.data.meta.lowest_price_rule = getLowestPricingRule(response.data.data.attributes.pricing_rules);
        return (0, deserializer_1.default)(response.data);
    }
    catch {
        return {};
    }
}
exports.getItemDeserializeFromApi = getItemDeserializeFromApi;
function getQuerySearchDeserializeFromApi(response) {
    try {
        const meta = response.data.meta;
        const data = getItemsDeserializeFromApi(response).data;
        return {
            data,
            meta,
        };
    }
    catch {
        return {
            data: [],
            meta: {},
        };
    }
}
exports.getQuerySearchDeserializeFromApi = getQuerySearchDeserializeFromApi;
//# sourceMappingURL=getItemsPayload.js.map